module.exports = __webpack_public_path__ + "static/media/sombra-lombada-debru-interna.90570b13.svg";